import { useState, useEffect, useCallback } from "react";
//hooks
import useHttp from "./useHttp";
// ----------------------------------------------------------------------
// https://api.sabasi.mobi/api/nandi/geo?sector=Health

const useFetchSabasiHealthGeoData = () => {
  const [healthGeo, setHealthGeo] = useState([]);
  const { isLoading, sendRequest } = useHttp();

  const fetchFilterSources = useCallback(async () => {
    try {
      const response = await sendRequest(
        `https://api.sabasi.mobi/api/nandi/geo?sector=Health`
      );
      if (response && response.data && response.data.length > 0) {
        setHealthGeo(response.data);
      }
    } catch (error) {}
  }, [sendRequest]);

  useEffect(() => {
    fetchFilterSources();
  }, [fetchFilterSources]);

  return { isLoading, healthGeo, setHealthGeo };
};

export default useFetchSabasiHealthGeoData;
